import { useState } from 'react';
import { MobileSheet, Stack, Row, Text, Input, Button } from '../ui';
import { api } from '../api/client';

export function LogPaymentModal({ payment, open, onClose, onSuccess }: { payment: any; open: boolean; onClose: () => void; onSuccess: () => void }) {
  const [referenceNumber, setReferenceNumber] = useState('');
  const [bankName, setBankName] = useState('');
  const [paymentMethod, setPaymentMethod] = useState('wire');
  const [loggedAt, setLoggedAt] = useState(() => new Date().toISOString().slice(0, 16));
  const [notes, setNotes] = useState('');
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');

  async function submit() {
    if (!referenceNumber.trim()) { setErr('reference number is required'); return; }
    setBusy(true); setErr('');
    try {
      await api.logPayment(payment.id, {
        referenceNumber: referenceNumber.trim(),
        bankName: bankName.trim() || undefined,
        paymentMethod,
        loggedAt: new Date(loggedAt).getTime(),
        notes: notes.trim() || undefined,
      });
      onSuccess(); onClose();
      setReferenceNumber(''); setBankName(''); setNotes('');
    } catch (e: any) { setErr(e.message ?? 'failed'); } finally { setBusy(false); }
  }

  if (!payment) return null;
  const amt = payment.amount?.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  return (
    <MobileSheet open={open} onClose={onClose} title="Log Payment">
      <Stack gap={3}>
        <div>
          <Text variant="small" className="font-medium">{payment.dealName ?? 'Deal'}</Text>
          <Text variant="label" muted>{payment.direction} · {payment.currency} {amt}</Text>
          {payment.description && <Text variant="label" muted>{payment.description}</Text>}
        </div>
        <Stack gap={2}>
          <Stack gap={0.5}>
            <Text variant="micro">reference number *</Text>
            <Input value={referenceNumber} onChange={e => setReferenceNumber(e.target.value)} placeholder="wire ref / SWIFT / ACH ID" className="w-full" />
          </Stack>
          <Stack gap={0.5}>
            <Text variant="micro">bank name</Text>
            <Input value={bankName} onChange={e => setBankName(e.target.value)} placeholder="Citibank, HSBC..." className="w-full" />
          </Stack>
          <Stack gap={0.5}>
            <Text variant="micro">payment method</Text>
            <select value={paymentMethod} onChange={e => setPaymentMethod(e.target.value)} className="h-9 hairline rounded-sm px-2 bg-bg text-sm w-full">
              {['wire','ACH','check','crypto','cash','other'].map(m => <option key={m} value={m}>{m}</option>)}
            </select>
          </Stack>
          <Stack gap={0.5}>
            <Text variant="micro">logged at</Text>
            <input type="datetime-local" value={loggedAt} onChange={e => setLoggedAt(e.target.value)} className="h-9 hairline rounded-sm px-2 bg-bg text-sm w-full" />
          </Stack>
          <Stack gap={0.5}>
            <Text variant="micro">notes</Text>
            <textarea value={notes} onChange={e => setNotes(e.target.value)} placeholder="optional notes" rows={2} className="hairline rounded-sm px-2 py-2 bg-bg text-sm w-full resize-none" />
          </Stack>
        </Stack>
        {err && <Text variant="small" className="text-negative">{err}</Text>}
        <Row gap={2} justify="end">
          <Button variant="ghost" onClick={onClose}>cancel</Button>
          <Button variant="primary" onClick={submit} disabled={busy}>{busy ? 'logging...' : 'log payment'}</Button>
        </Row>
      </Stack>
    </MobileSheet>
  );
}
